import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'jalali-moment';
import { Router } from '@angular/router';
import { PaymentEntity } from 'src/app/shared';
import { PaymentStatus } from 'src/app/core';
import { PaymentService } from '../../../../feature/payment/services';

type IconTagsType = ('print' | 'thesis-edit' | 'thesis')[];

@Component({
  selector: 'app-payment-review',
  templateUrl: './payment-review.component.html',
  styleUrls: ['./payment-review.component.sass'],
})
export class PaymentReviewComponent implements OnInit {
  @Input() payment!: PaymentEntity;
  @Output() onCancel = new EventEmitter<number>();

  public statuses = PaymentStatus;
  public deletionTimeEstimate: string = '60';
  public iconTags: ('print' | 'thesis-edit' | 'thesis')[] = [];

  constructor(
    // private jalaliDateCalculator: JalaliDateCalculatorService,
    private router: Router,
    private paymentService: PaymentService,
  ) {}

  ngOnInit(): void {
    this.iconTags = this.generateIconTags();
    this.calculateDeletionTime();
  }

  // ------------------------------ Getters & Setters|

  public get reviewMode():
    | 'processing'
    | 'waiting-payment'
    | 'canceled'
    | 'delivered'
    | 'not-defined' {
    if (
      this.payment.status === this.statuses.Done ||
      this.payment.status === this.statuses.Implementation
    ) {
      return 'processing';
    } else if (
      this.payment.status === this.statuses.Payment &&
      this.payment.isFinalized
    ) {
      return 'waiting-payment';
    } else if (this.payment.status === this.statuses.Canceled) {
      return 'canceled';
    }

    return 'not-defined';
  }

  // ----------------------------- Public methods|



  public toJalaliDate(date?: Date) {
    if (!date) return 'نامشخص';
    // const jDate = this.jalaliDateCalculator.convertToJalali(new Date(date));
    // return `${jDate.year}/${jDate.month}/${jDate.day}`;
    return moment(date).locale('fa').format('YYYY/MM/DD');
  }

  public complete() {
    if (this.payment.isFinalized) {
      // this.router.navigate(['/payment'], {
      //   queryParams: {
      //     complete: this.payment.factorNumber,
      //   },
      // });
      this.paymentService.startPaymentAndRedirect(this.payment.id);
    }
  }

  public trackPayment() {
    window.open(
      `https://tracking.post.ir/search.aspx?id=${this.payment.trackingCode}`
    );
  }

  public downloadFactor() {}
  public leaveComment() {}

  public cancelPayment() {
    this.onCancel.emit(this.payment.id);
  }

  public calculateDeletionTime() {
    const currentTime = new Date();
    const createdTime = new Date(this.payment.createdAt!);

    const sixtyMinutesNextTime = new Date(
      createdTime.getTime() + 60 * 60 * 1000
    );

    let remainingMinutes =
      (sixtyMinutesNextTime.getTime() - currentTime.getTime()) / 1000 / 60;

    remainingMinutes = remainingMinutes < 0 ? 0 : remainingMinutes;

    this.deletionTimeEstimate = remainingMinutes.toFixed(0);
  }

  // ---------------------------- Private Methods|

  private generateIconTags(): IconTagsType {
    const tags: IconTagsType = [];

    for (let order of this.payment.orders!) {
      if (!tags.includes(order.type)) {
        tags.push(order.type);
      }
    }

    return tags;
  }
}
